import { Button, InfiniteTable, Row } from "globalComponents";
import ExportCSV from "globalComponents/ExportCSV";
import { formatDollars } from "globalResources/helpers";
import React, { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import styled from "styled-components";
import PositionModal from "./PositionModal";
import axios from "axios";
import { errorHandler } from "globalResources/util";

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  font-weight: 600;
  font-size: 20px;
  margin: 0;
`;

const headers = [
  { label: "UID", render: (row) => <div>{row.user.UID}</div>, width: "30%" },
  {
    label: "Name",
    render: (row) => <div>{`${row.user.firstName} ${row.user.lastName}`}</div>,
  },
  {
    label: "Position",
    render: (row) => <div>{row.name}</div>,
  },
  {
    label: "Bill Rate",
    render: (row) => (
      <div>
        ${formatDollars(row.billRate / 100)} ($
        {formatDollars(row.overtimeBillRate / 100)})
      </div>
    ),
  },
  {
    label: "Pay Rate",
    render: (row) => (
      <div>
        ${formatDollars(row.payRate / 100)} ($
        {formatDollars(row.overtimePayRate / 100)})
      </div>
    ),
  },
];

const EmployeeList = ({ client }) => {
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [positions, setPositions] = useState([]);

  const fetchPositions = async () => {
    try {
      const res = await axios.get("/positions", {
        params: { clientId: client._id },
      });
      res.data.sort((a, b) => (a.user.firstName > b.user.firstName ? 1 : -1));
      setPositions(res.data);
    } catch (err) {
      const error = errorHandler(err);
    }
  };

  const format4CSV = () => {
    return positions.map((row) => ({
      UID: row.user.UID,
      externalId: row.user.externalId,
      EmployeeName: `${row.user.firstName} ${row.user.lastName}`,
      AddressLine1: row.user.addressLine1,
      AdderssLine2: row.user.addressLine2,
      State: row.user.state,
      Zipcode: row.user.zipcode,
      Position: row.name,
      accountType: row.user.accountType,
      TaxType: row.user.employeeType,
      BillRate: (row.billRate / 100).toFixed(2),
      PayRate: (row.payRate / 100).toFixed(2),
      ClientName: client.name,
      ClientAddress: `${client.address} ${client.city} ${client.state}, ${client.zipcode}`,
    }));
  };

  useEffect(() => {
    fetchPositions();
  }, [client]);

  return (
    <Main>
      <Row style={{ alignItems: "center", padding: "10px 0" }}>
        <Title>Employees ({positions.length})</Title>
        <Row style={{ marginLeft: "auto", alignItems: "center" }}>
          <ExportCSV
            label="Export Employees"
            data={format4CSV()}
            filename={`${client.name}-employees-${moment().format("lll")}.csv`}
          />
          <Button width="150px" onClick={() => setSelectedPosition("0")}>
            + Add Employee
          </Button>
        </Row>
      </Row>
      <InfiniteTable
        height="400px"
        data={positions}
        headers={headers}
        onClick={(row) => setSelectedPosition(row._id)}
      />
      {selectedPosition !== null && (
        <PositionModal
          id={selectedPosition}
          clientId={client._id}
          onClose={() => {
            setSelectedPosition(null);
            fetchPositions();
          }}
        />
      )}
    </Main>
  );
};
export default EmployeeList;
